import { MessageCircleMore } from "lucide-react"
import { useState } from "react"
import { Link } from "react-router-dom"
import Logo from "../components/icons/Logo"

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-900 shadow-md">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/">
          <div className="flex items-center gap-2 text-white">
            <Logo width="50px" stroke="white" />
            <span className="text-2xl font-bold">AutoLink</span>
          </div>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8 text-gray-300">
          <p className="hover:text-white transition font-bold tracking-wide text-lg">
            Servicios
          </p>
          <Link to="/#servicios" className="hover:text-white transition">
            Compra
          </Link>
          <Link to="/#servicios" className="hover:text-white transition">
            Venta
          </Link>
          <Link to="/#" className="hover:text-white transition">
            Nosotros
          </Link>
          <a
            href="https://wa.link/2xqw6j"
            rel="noopener noreferrer"
            target="_blank"
            className="flex items-center gap-2 bg-white text-gray-900 px-6 py-2 rounded-full hover:bg-gray-100 transition"
          >
            <MessageCircleMore />
            Whatsapp
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden ${isMenuOpen ? "block" : "hidden"} absolute top-0 left-0 right-0 bg-gray-900 p-6 text-white`}
      >
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-white"
          onClick={() => setIsMenuOpen(false)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>

        <p className="block mb-4 font-bold tracking-wide text-lg">Servicios</p>
        <Link
          to="/#servicios"
          className="block mb-4"
          onClick={() => setIsMenuOpen(false)}
        >
          Compra
        </Link>
        <Link
          to="/#servicios"
          className="block mb-4"
          onClick={() => setIsMenuOpen(false)}
        >
          Venta
        </Link>
        <Link
          to="/#"
          className="block mb-4"
          onClick={() => setIsMenuOpen(false)}
        >
          Nosotros
        </Link>
        <a 
          className="flex items-center gap-3 justify-center w-full bg-white text-gray-900 px-6 py-2 rounded-full hover:bg-gray-200 transition mt-5"
          href="https://wa.link/2xqw6j"
          rel="noopener noreferrer"
          target="_blank" 
        >
          Whatsapp
          <MessageCircleMore />
        </a>
      </div>
    </nav>
  )
}

export default Navbar
